<template>
    <v-layout row justify-center>
        <v-dialog v-model="modaluserlike" persistent scrollable max-width="360px">
            <v-card>
                <!--v-layout justify-center>
                    <v-flex xs11>
                        <v-text-field
                                v-model="inputsearchlaundries"
                                outline
                                label="Buscar"
                                append-icon="search"
                                @keyup="searchingfavoriteslaundries"
                        ></v-text-field>
                    </v-flex>
                </v-layout-->
                <v-card-text style="height: 300px;">
                    <div v-if="userlikes.length<=0">
                        <label>{{language==='English'?'there are no data':'No hay datos'}}</label>
                    </div>
                    <!--card-product-->
                    <div class="overflow:scroll">
                        <div class="card-favorites" v-for="(userlikes, index) in userlikes" :key="userlikes.length">
                            <img style="border-radius:100%; padding:10px; cursor:pointer" :src="userlikes._id_user.photo[0].link">
                                <!--Product name-->
                            <div class="card-favorites-infos"  style="cursor:pointer" @click="goprofileuser(userlikes._id_user.username)">
                                <p style="font-size:14px">{{userlikes._id_user.fullname}}</p>
                            </div>
                        </div>
                        <infinite-loading @infinite="infiniteHandler"/>
                    </div>
                </v-card-text>
                <div class="text-center">
                    <v-btn color="primary" @click="closemodaluserlike">{{language==='English'?'Close':'Cerrar'}}</v-btn>
                </div>
            </v-card>
        </v-dialog>
  </v-layout>
</template>
<script>
import {EventBus} from '@/helpers/eventbus/event-bus'
import InfiniteLoading from 'vue-infinite-loading'
import env from '../../../config/env.example'
import {PostService} from "@/services"


export default {
    data(){
        return{
            language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
            modaluserlike: false,
            userlikes:[],
            page:0,
        }
    },
    components: {
        'infinite-loading':InfiniteLoading
    },
    props:{
        idpost:''
    },
    mounted(){
        if(this.idpost!==''){
            this.infiniteHandler()
        }
        
        EventBus.$on('openmodaluserlike',(idpost)=>{
            this.idpost = idpost
            this.modaluserlike = true
            if(this.idpost!==''){
                //console.log(this.idpost)
                this.infiniteHandler()

            }
        })
        /*
        EventBus.$on('getsignalfollowerdeleted',(datauser)=>{
            this.followers =  this.followers.filter(followers =>String(followers._id_user._id) !== String(datauser.id))
        })
        EventBus.$on('newfollower',(newfollower)=>{
            if(newfollower){
                this.followers =  this.followers.concat(newfollower)
            }
        })*/
    },
    methods:{
        closemodaluserlike(){
            this.modaluserlike = false
            this.userlikes = []
            EventBus.$emit('closemodallikeuser')
        },
        goprofileuser(username){
            window.location = `${env.host}${username}`
        },
        /*
        deleteuserfollower(iduserfollower){
			let data = {
				_id_user:this.iduser,
				id: iduserfollower
            }
            UsersService.stopfollowingthisuser(data).then(res=>{
				let datasend = {
					iduser: this.iduser,
					id: iduserfollower
				}
				this.$socket.emit('signaldeletefollower',datasend)
			})
			
		},*/
        infiniteHandler: function ($state) {
            let limit = this.userlikes.length / 40 + 1;
            let data = {
                idpost:this.idpost,
                page: limit
            }
            PostService.getuserlike(data).then(res=>{
				this.loadMore($state, res)
			})
        },
        loadMore: function ($state, response) {
            if(!response.data.userlikes.length <=0){
                if ( response.data.userlikes.length ) {
                    this.userlikes = this.userlikes.concat(response.data.userlikes)
                    setTimeout(() => {
                        $state.loaded()
                    }, 3000);
                    /*
                    if ( response.followers.length == this.followers.length ) {
                        $state.complete();
                    }*/
                } else {
                    $state.complete()
                }
            }else{
                $state.complete()
            }
        },
            
        /*
        infiniteHandler($state){
            this.page++
            let data = {
                _id_user:this.iduser,
                page: this.page
            }
            this.axios.post('users/getfollowers',data)
            .then(res=>{
                let followers = res.data.followers
                console.log(followers)
                if(followers.length){
                    this.followers = this.followers.concat(followers)
                    $state.loaded()
                }else{
                    $state.complete()
                }
            })
        }*/
    }
}
</script>
<style lang="scss" scoped>
    /*favorites name*/
    .card-favorites {
        overflow: hidden;
        height: 120px;
        background: white;
        box-shadow: 0 0 15px rgba(0,0,0,0.2);
        display: flex;
        align-items: center;
        margin-top: 20px
    }

    .card-favorites img {
        height: 80%;
        width: 100px;
        object-fit: cover;
    }

    .card-favorites h2 {
        font-size: 16px;
        font-weight: bold;
        margin: 0;
    }

    .card-favorites p {
        font-size: 12px;
        line-height: 1.4;
        opacity: .7;
        margin-bottom: 0;
        margin-top: 8px;
    }

    
</style>
